export type NationalityOption = {
  value: string;
  label: string;
};

export const normalizeNationalityValue = (
  value: string,
  options: NationalityOption[] = [],
) => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return "";
  }

  const valueLower = trimmedValue.toLowerCase();
  const matchedOption = options.find(
    (option) =>
      option.value.toLowerCase() === valueLower ||
      option.label.toLowerCase() === valueLower,
  );

  if (matchedOption) {
    return matchedOption.value;
  }

  if (valueLower === "malaysia") {
    return "MYS";
  }

  return trimmedValue;
};
